import { useEffect, useState } from "react";
import { Compass, Users, Star, ArrowRight, X } from "lucide-react";

const STORAGE_KEY = "su_explorer_tour_seen";

const STEPS = [
  { icon: Compass, title: "Welcome, Explorer!", body: "Scout Navigator is your window into the whole SportsUnity talent pool — the same powerful discovery scouts and coaches use." },
  { icon: Users, title: "Filter & discover", body: "Search by role, position, country, profession and performance data to find exactly the athletes or professionals you're looking for." },
  { icon: Star, title: "Shortlist & connect", body: "Save people to your shortlist and send connection requests right from a profile. Your network grows from here." },
];

// One-time intro for Explorer users, shown on their first Scout Navigator visit.
export default function ExplorerTour({ role }) {
  const [step, setStep] = useState(0);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (role !== "explorer") return;
    if (typeof window === "undefined") return;
    if (!window.localStorage.getItem(STORAGE_KEY)) setOpen(true);
  }, [role]);

  const close = () => {
    try { window.localStorage.setItem(STORAGE_KEY, "1"); } catch { /* ignore */ }
    setOpen(false);
  };

  if (!open) return null;
  const Icon = STEPS[step].icon;
  const isLast = step === STEPS.length - 1;

  return (
    <div className="fixed inset-0 z-[90] bg-black/50 flex items-center justify-center p-4" data-testid="explorer-tour">
      <div className="bg-white rounded-xl w-full max-w-sm overflow-hidden shadow-2xl">
        <div className="relative h-28 bg-gradient-to-br from-[#074572] to-[#0a5a8f] flex items-center justify-center">
          <div className="w-14 h-14 rounded-full bg-white/15 flex items-center justify-center">
            <Icon size={26} className="text-white" />
          </div>
          <button onClick={close} className="absolute top-3 right-3 text-white/80 hover:text-white" data-testid="explorer-tour-skip" aria-label="Skip">
            <X size={18} />
          </button>
        </div>
        <div className="p-6 text-center">
          <h3 className="text-lg font-semibold text-zinc-900" style={{ fontFamily: "Outfit" }}>{STEPS[step].title}</h3>
          <p className="text-sm text-zinc-500 mt-2 leading-relaxed">{STEPS[step].body}</p>
          <div className="flex items-center justify-center gap-1.5 mt-5">
            {STEPS.map((_, i) => (
              <span key={i} className={`h-1.5 rounded-full transition-all ${i === step ? "w-6 bg-[#074572]" : "w-1.5 bg-zinc-200"}`} />
            ))}
          </div>
          <button
            onClick={() => (isLast ? close() : setStep((s) => s + 1))}
            className="w-full mt-5 h-10 rounded-md bg-[#F85037] hover:bg-[#e04530] text-white text-sm font-medium flex items-center justify-center gap-2"
            data-testid="explorer-tour-next"
          >
            {isLast ? "Start exploring" : "Next"} <ArrowRight size={15} />
          </button>
          {!isLast && (
            <button onClick={close} className="mt-2 text-xs text-zinc-400 hover:text-zinc-600" data-testid="explorer-tour-skip-link">Skip tour</button>
          )}
        </div>
      </div>
    </div>
  );
}
